import { useState } from "react";
import { AppInfo } from "../../../service/app-manager/AppManager";
// @ts-ignore
import styles from "./CreateProject.module.scss"
import { useApps, useOpenApp } from "./util/useApp";
import { message } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectIntl } from "../../../redux/intl/intlSlice";

const AppCard = (props: { app: AppInfo, onClick: (app: AppInfo) => void, order: number }) => {
    const { app, onClick, order } = props;
    const [hover, setHover] = useState(false);
    const { t } = useTranslation();
    const { locale } = useSelector(selectIntl)
    const orderIndicator = app.category === 'coding' ? 'C' : app.category === 'model' ? 'M' : app.category === 'ui' ? 'U' : ''

    return (
        <div className={styles.card} onClick={() => onClick(app)} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
            <div className={styles.titleContainer}>
                <div className={styles.cardTtile}>{app.name[locale] || (locale === "zh-tw" ? app.name["zh-cn"] : app.name["en"])}</div>
                <img src="/home/right.png" className={styles.findIcon} alt="" />
            </div>
            <div className={styles.contentWrapper}>
                <div className={styles.textGroup}>
                    {
                        app.detailDescription && hover ? <div className={styles.cardDetailDescription}>{app.detailDescription[locale] || (locale === "zh-tw" ? app.detailDescription["zh-cn"] : app.detailDescription["en"])}</div> :
                            <div className={styles.cardDescription}>{app.description[locale] || (locale === "zh-tw" ? app.description["zh-cn"] : app.description["en"])}</div>
                    }
                    {
                        app.detailDescription && hover ? null : (
                            app.canUse ?
                                <div className={styles.cardOrder}>{`${orderIndicator}${order}`}</div> :
                                <div className={styles.tips}>
                                    {t('in_development') as string}
                                </div>
                        )
                    }
                </div>
                <div className={styles.cardImage}>
                    {
                        app.dynamicCover && hover ? <img src={app.dynamicCover} alt="" /> : <img src={app.cover} alt="" />
                    }
                </div>
            </div>
        </div>
    )
}

export const CreateProject = () => {
    const { apps } = useApps();
    const { openApp } = useOpenApp();
    const { t } = useTranslation();
    
    const onAppClick = (app: AppInfo) => {
        if(app.category === 'model') {
            if (!app.canUse) {
            message.warning({
                content: t('feature_unavailable') as string,
                className: styles.message,
            });
            return;
        }
            message.warning({
                content: t('online_unsupported') as string,
                className: styles.message,
            });
            return;
        }
        if (!app.canUse) {
            message.warning({
                content: t('feature_unavailable') as string,
                className: styles.message,
            });
            return;
        }
        openApp(app);
    }
    
    return (
        <div className={styles.createProject}>
            <div id="coding" className={styles.category}>
                <div className={styles.categoryTitle}>
                    <div className={styles.titleContainer}>
                        <img className={styles.iconSize} src="/home/projects-coding.png" alt="" />
                        <div className={styles.text} >{t('projectCoding') as string}</div>
                    </div>
                </div>
                <div className={styles.categoryItemWrapper}>
                    {apps.filter(item => item.category === "coding").map(
                        (item, index) => <AppCard key={item.id} app={item} onClick={onAppClick} order={index + 1} />
                    )}
                </div>
            </div>
            <div id="model" className={styles.category}>
                <div className={styles.categoryTitle}>
                    <div className={styles.titleContainer}>
                        <img className={styles.iconSize} src="/home/projects-model.png" alt="" />
                        <div className={styles.text} >{t('projectModel') as string}</div>
                    </div>
                </div>
                <div className={styles.categoryItemWrapper}>
                    {apps.filter(item => item.category === "model").map(
                        (item, index) => <AppCard key={item.id} app={item} onClick={onAppClick} order={index + 1} />
                    )}
                </div>
            </div>
            <div id="ui" className={styles.category}>
                <div className={styles.categoryTitle}>
                    <div className={styles.titleContainer}>
                        <img className={styles.iconSize} src="/home/projects-view.png" alt="" />
                        <div className={styles.text} >{t('projectView') as string}</div>
                    </div>
                </div>
                <div className={styles.categoryItemWrapper}>
                    {apps.filter(item => item.category === "ui").map(
                        (item, index) => <AppCard key={item.id} app={item} onClick={onAppClick} order={index + 1} />
                    )}
                </div>
            </div>
        </div>
    )
}